import theme from '@styles/theme';
export default {
  section: {
    position: 'relative',
    background: theme.rawColors.lightGrey300,
    zIndex: theme.zIndex.documentUp
  },
  block: {
    padding: '0',
    display: ['flex', 'block'],
    flexDirection: 'column-reverse',
    height: ['auto', '784px', '1024px', '46.875vw'],
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  },
  bgContainer: (isVideo: boolean) => ({
    height: ['177.77777778vw', '177.77777778vw', '100%'],
    position: ['relative', 'absolute'],
    overflow: 'hidden',
    bottom: '0',
    left: '0',
    right: '0',
    ...(isVideo ? {
      cursor: 'pointer'
    } : {}),
    img: {
      transition: 'opacity .15s',
      height: '100%',
      width: '100%'
    }
  }),
  playVideoOverlay: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: theme.zIndex.documentUp,
    cursor: 'pointer',
    pointerEvents: 'auto',
    display: ['none', 'none', 'none', 'none', 'block']
  },
  textWrapper: {
    zIndex: theme.zIndex.documentUp,
    position: 'relative',
    pointerEvents: 'none',
    'a, button': {
      pointerEvents: 'auto'
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: ['flex-start', 'flex-start', 'flex-end'],
    alignItems: 'center',
    height: '100%',
    bottom: 0,
    'h2.display__three.mobile, h4.headings.heading__four.mobile': {
      color: [theme.rawColors.darkGrey700, theme.rawColors.darkGrey700, theme.rawColors.neutralWhite]
    },
    'h4.headings.heading__four.mobile': {
      pb: [16, 0, 40],
      maxWidth: 910,
      width: '100%'
    },
    p: ['10.6666667vw 16px 0', '10.6666667vw 16px 0', '5.2vw 16px 100px', '5.2vw 16px 100px', '150px 20px 100px 20px']
  },
  sliderTopText: (color?: string) => ({
    fontSize: theme.fontSizes.bigText,
    fontWeight: theme.fontWeights.normal,
    color: color || theme.rawColors.neutralWhite,
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center'
  }),
  buttonLinkPosition: {
    position: ['absolute', 'absolute', 'relative'],
    bottom: ['-464px', '56px', '0']
  }
};